export default __webpack_public_path__ + "static/media/data_fields1.bdaf8307.png";